import { PageModel } from '@adobe/aem-react-editable-components';
import { Constants } from '@adobe/aem-spa-page-model-manager';

const { ITEMS_PROP, ITEMS_ORDER_PROP } = Constants;

const manipulator = (pageModel: PageModel) => {
	const parsedModel = JSON.parse(
		JSON.stringify(pageModel),
	) as typeof pageModel;

	const rootItemKey = parsedModel?.[ITEMS_ORDER_PROP]?.[0];

	parsedModel?.[ITEMS_PROP]?.[rootItemKey!]?.[ITEMS_ORDER_PROP]?.sort(
		(a, b) => {
			const aStartsWithWelcome = a.startsWith('welcomebanner');
			const bStartsWithWelcome = b.startsWith('welcomebanner');

			if (aStartsWithWelcome && !bStartsWithWelcome) return -1;
			if (!aStartsWithWelcome && bStartsWithWelcome) return 1;
			return 0;
		},
	);

	try {
		return parsedModel;
	} catch {
		return pageModel;
	}
};

export default manipulator;
